import api from "../api";


export const getDevices = async () => {
  try {
    const response = await api.get("mivulite/devices?accepted=true");
    return response.data;
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};


export const getAllDevices = async () => {
  try {
    const response = await api.get("mivulite/devices");
    return response.data;
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};


export const getAllDevicesbyOrg = async (orgID) => {
  try {
    const response = await api.get(`mivulite/devices?organization_id=${orgID}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};



export const getUnacceptedDevices = async () => {
  try {
    const response = await api.get("mivulite/devices?accepted=false");
    return response.data;
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};


export const deviceHeartbeat = async (data) => {
  try {
    const response = await api.post("mivulite/devices/heartbeat", data);
    return response.data;
  } catch (error) {
    console.error("Error sending device heartbeat:", error);
    throw error;
  }
};


export const createDevice = async (data) => {
  try {
    const response = await api.post("mivulite/devices/register", data);
    return response.data;
  } catch (error) {
    console.error("Error registering device:", error);
    throw error;
  }
};


export const getDevice = async (mac) => {
  try {
    const response = await api.get(`mivulite/devices/${mac}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching device ${mac}:`, error);
    throw error;
  }
};


export const deleteDevice = async (mac) => {
  try {
    const response = await api.delete(`mivulite/devices/mac/${mac}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting device ${mac}:`, error);
    throw error;
  }
};


export const acceptDevice = async (mac) => {
  try {
    const response = await api.put(`mivulite/devices/mac/${mac}/accept`);
    return response.data;
  } catch (error) {
    console.error(`Error accepting device ${mac}:`, error);
    throw error;
  }
};


export const assignDeviceToUser = async (mac, data) => {
  try {
    const response = await api.post(`mivulite/devices/mac/${mac}/assign`, data);
    return response.data;
  } catch (error) {
    console.error(`Error assigning device ${mac}:`, error);
    throw error;
  }
};


export const getDeviceConfigByMac = async (mac) => {
  try {
    const response = await api.get(`mivulite/devices/mac/${mac}/config`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching config for device ${mac}:`, error);
    throw error;
  }
};


export const updateDevice = async (mac, config) => {
  try {
    const response = await api.patch(`mivulite/devices/mac/${mac}/config`, config);
    return response.data;
  } catch (error) {
    console.error(`Error updating config for device ${mac}:`, error);
    throw error;
  }
};



export const getDeviceResults = async (mac) => {
  try {
    const response = await api.get(`mivulite/devices/mac/${mac}/results`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching results for device ${mac}:`, error);
    throw error;
  }
};



export const submitDeviceResults = async (mac, data) => {
  try {
    const response = await api.post(`mivulite/devices/mac/${mac}/results`, data);
    return response.data;
  } catch (error) {
    console.error(`Error submitting results for device ${mac}:`, error);
    throw error;
  }
};